export function getPostcode(options) {
  const daum = window.daum;
  const setters = options && typeof options === 'object' ? options : null;

  new daum.Postcode({
    oncomplete: function (data) {
      var roadAddr = data.roadAddress || '';

      var postcodeEl = document.getElementById('postcode');
      var roadEl = document.getElementById('roadAddress');
      var jibunEl = document.getElementById('jibunAddress');
      if (postcodeEl) postcodeEl.value = data.zonecode || '';
      if (roadEl) roadEl.value = roadAddr;
      if (jibunEl) jibunEl.value = data.jibunAddress || '';

      if (setters) {
        if (typeof setters.setZipCode === 'function')
          setters.setZipCode(data.zonecode || '');
        if (typeof setters.setAddr === 'function') setters.setAddr(roadAddr);
        if (typeof setters.setJibun === 'function')
          setters.setJibun(data.jibunAddress || '');
      }

      var guideTextBox = document.getElementById('guide');
      if (guideTextBox) {
        if (data.autoRoadAddress) {
          guideTextBox.innerHTML =
            '(예상 도로명 주소 : ' + data.autoRoadAddress + ')';
          guideTextBox.style.display = 'block';
        } else if (data.autoJibunAddress) {
          guideTextBox.innerHTML =
            '(예상 지번 주소 : ' + data.autoJibunAddress + ')';
          guideTextBox.style.display = 'block';
        } else {
          guideTextBox.innerHTML = '';
          guideTextBox.style.display = 'none';
        }
      }
    },
  }).open();
}
